module.exports = __webpack_public_path__ + "media/images/emoticons/beer-0062bb34541d93ac71dcf5f0ea39a482.gif";